var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticStyle: { "z-index": "600" },
      attrs: { "max-width": "700", light: true },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "absX",
                  on: {
                    "&click": function ($event) {
                      return _vm.cancleDialog.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myGray", attrs: { "x-large": "" } },
                    [_vm._v("mdi-window-close")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "spacer-25" }),
              _c(
                "h3",
                { staticClass: "mt-4", staticStyle: { padding: "0 24px" } },
                [
                  _vm._v(
                    "Anmerkungen für " +
                      _vm._s(_vm.displayItemVol(_vm.item)) +
                      " " +
                      _vm._s(_vm.item.nameToDisplay)
                  ),
                ]
              ),
              _c(
                "v-card-text",
                [
                  _c("div", { staticStyle: { height: "15px" } }),
                  _c("v-text-field", {
                    ref: "notesInput",
                    attrs: {
                      label: "Anmerkungen",
                      placeholder: "Hier eingeben...",
                      autofocus: true,
                      "hide-details": "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.doProcess.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.notes,
                      callback: function ($$v) {
                        _vm.notes = $$v
                      },
                      expression: "notes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c("div", { staticClass: "mr-4 underline text-center" }, [
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        on: {
                          "&click": function ($event) {
                            $event.stopPropagation()
                            return _vm.cancleDialog.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Abbrechen")]
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-df",
                      attrs: { text: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.doProcess.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" OK ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }